import {Component, OnInit} from '@angular/core';
import {SECTIONS} from '../nav-items/nav-items';
import {LOG_ENTRIES} from '../../shared/log-helper/log-helper.service';
import {Log} from 'ng2-logger';

const SECTIONS_KEYS = Object.keys(SECTIONS);
// logger
const log = Log.create(LOG_ENTRIES.navbar.name);
log.color = LOG_ENTRIES.navbar.color;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  get sections() {
    return SECTIONS;
  }

  get sectionKeys() {
    return SECTIONS_KEYS;
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/navbar/navbar.component.ts